import { apiClient, type ApiClientResponse } from '@/datasources/apiClient'
import type { Organization } from '@/types'

export const fetchOrgsApi = (): Promise<ApiClientResponse<Organization[]>> =>
  apiClient.get('/api/v1/orgs').then((r) => r.data)

export const createOrgApi = (name: string): Promise<ApiClientResponse<Organization>> =>
  apiClient.post('/api/v1/orgs', { name }).then((r) => r.data)


export const updateOrgApi = (orgId: string, data: { name?: string }): Promise<ApiClientResponse<Organization>> =>
  apiClient.patch(`/api/v1/orgs/${orgId}`, data).then((r) => r.data)

export const deleteOrgApi = (orgId: string): Promise<ApiClientResponse<null>> =>
  apiClient.delete(`/api/v1/orgs/${orgId}`).then((r) => r.data)

